import OverrideService from '@launchpad/logic/services/overrides/OverrideService';
import ChangePasswordPage from '@launchpad/modules/auth/pages/ChangePasswordPage';
import React, { Component } from 'react';
import { Switch } from 'react-router-dom';
import { AppRoute, LPOverridable } from '../../index';
import ForgotPassword from '../../modules/auth/pages/ForgotPassword';
import LoginPage from '../../modules/auth/pages/LoginPage';
import OTPPage from '../../modules/auth/pages/OTPPage';
import ScaCodePage from '@launchpad/modules/auth/pages/ScaCodePage';

export default class PublicLayout extends Component {
  constructor(props) {
    super(props);
    this.match = props.match;
  }

  componentDidMount() {
    const token = localStorage.getItem('token');
    if (token) {
      // this.props.history.push("/dashboard");
    }
  }

  render() {
    return (
      <div>
        <div className="container-fluid login-page">
          <LPOverridable name="login.page.logo">
            <img
              className="login-logo"
              src={require('../../assets/Launchpad_logoWhite.png')}
              alt=""
            />
          </LPOverridable>
          <LPOverridable name="login.page.text">
            <h1>
              Welcome to{' '}
              <span style={{ display: 'block', textAlign: 'center' }}>
                BankVault
              </span>
            </h1>
          </LPOverridable>
          <div className="login-box">
            <div className="white-blur" />
            <div className="inner">
              <Switch>
                <AppRoute
                  path="/forgot-password"
                  component={
                    OverrideService.getOverrides()[
                      'forgot-password-override-page'
                    ] || ForgotPassword
                  }
                  unAuthenticatedOnly
                />
                <AppRoute
                  path="/login"
                  exact
                  component={
                    OverrideService.getOverrides()['login-override-page'] ||
                    LoginPage
                  }
                  unAuthenticatedOnly
                />
                <AppRoute
                  path="/login/otp"
                  component={OTPPage}
                  unAuthenticatedOnly
                />
                <AppRoute
                  path="/login/change-password"
                  component={ChangePasswordPage}
                  unAuthenticatedOnly
                />
                <AppRoute
                  path="/login/sca-code-verification"
                  component={ScaCodePage}
                  unAuthenticatedOnly
                />
              </Switch>
            </div>
          </div>
        </div>
        <footer className="public-layout-footer">
          <p>©{new Date().getFullYear()} Pannovate. All rights reserved.</p>
          <p>European Patent Application No. 14704638.7</p>
        </footer>
      </div>
    );
  }
}
